import { IndexedDBCache } from '~/services/cache/IndexedDBCache.ts'

let isInitialized = false

interface ContentsquarePageViewContext {
  sessionKey?: string
}

async function captureContentsquareUserId(context: ContentsquarePageViewContext): Promise<void> {
  if (!stores.user.authenticated || !context.sessionKey) return

  const user = stores.user.user
  const [contentsquareUserId] = context.sessionKey.split('.')
  if (!contentsquareUserId) return

  const contentsquareUserIdsCache = IndexedDBCache.tags([`user:${user.id}`, 'ContentsquareUserIds'])
  if (await contentsquareUserIdsCache.has(contentsquareUserId).catch(() => false)) return

  await api
    .post('user/contentsquare-ids', {
      contentsquare_user_id: contentsquareUserId,
    })
    .then(() => contentsquareUserIdsCache.put(contentsquareUserId, true, dayjs().add(1, 'week')))
    .catch(() => undefined)
}

function trackPageView() {
  if (!isInitialized) return
  window._uxa.push(['trackPageview', window.location.pathname + window.location.hash.replace('#', '?__')])
}

function init() {
  if (isInitialized || !$env.contentsquare.tag_id) {
    return
  }
  window._uxa = window._uxa || []

  window._uxa.push(['setPath', window.location.pathname + window.location.hash.replace('#', '?__')])
  window._uxa.push(['afterPageView', captureContentsquareUserId])
  let script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://t.contentsquare.net/uxa/${$env.contentsquare.tag_id}.js`
  document.getElementsByTagName('head')[0].appendChild(script)
  isInitialized = true
}

export function useContentsquareTracking() {
  return {
    init,
    trackPageView,
  }
}
